module.exports = __webpack_public_path__ + "static/eth-merge-rocket-ded0a85823b207334b04370fedfc3907.mp4";